import { SVGProps } from 'react'

export const CameraIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M1.33334 5.58486C1.33334 5.35131 1.33334 5.23454 1.34309 5.13618C1.43708 4.18755 2.18752 3.43711 3.13615 3.34312C3.23451 3.33337 3.35758 3.33337 3.60373 3.33337C3.69858 3.33337 3.746 3.33337 3.78627 3.33094C4.30042 3.2998 4.75064 2.97529 4.94277 2.49737C4.95782 2.45995 4.97188 2.41776 5.00001 2.33337C5.02814 2.24899 5.0422 2.2068 5.05725 2.16937C5.24938 1.69146 5.6996 1.36695 6.21375 1.33581C6.25402 1.33337 6.29849 1.33337 6.38744 1.33337H9.61258C9.70153 1.33337 9.746 1.33337 9.78627 1.33581C10.3004 1.36695 10.7506 1.69146 10.9428 2.16937C10.9578 2.2068 10.9719 2.24899 11 2.33337C11.0281 2.41776 11.0422 2.45995 11.0572 2.49737C11.2494 2.97529 11.6996 3.2998 12.2138 3.33094C12.254 3.33337 12.3014 3.33337 12.3963 3.33337C12.6424 3.33337 12.7655 3.33337 12.8639 3.34312C13.8125 3.43711 14.5629 4.18755 14.6569 5.13618C14.6667 5.23454 14.6667 5.35131 14.6667 5.58486V10.8C14.6667 11.9201 14.6667 12.4802 14.4487 12.908C14.2569 13.2843 13.951 13.5903 13.5747 13.7821C13.1468 14 12.5868 14 11.4667 14H4.53334C3.41324 14 2.85319 14 2.42536 13.7821C2.04904 13.5903 1.74308 13.2843 1.55133 12.908C1.33334 12.4802 1.33334 11.9201 1.33334 10.8V5.58486Z"
      stroke="#344054"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00001 11C9.47277 11 10.6667 9.80613 10.6667 8.33337C10.6667 6.86061 9.47277 5.66671 8.00001 5.66671C6.52725 5.66671 5.33334 6.86061 5.33334 8.33337C5.33334 9.80613 6.52725 11 8.00001 11Z"
      stroke="#344054"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
